
import React, { Component, useEffect } from "react";
import userManager from "../util/userManager";

const LogoutPage = () => {

    useEffect(() => {
        userManager.signoutRedirect();
    });


    return (
        <div>
            <h3>Log out</h3>
        </div>
    );

}

export default LogoutPage;